export const DEFAULT_NAVIGATION_LAYOUT = 'auroraMotion';

export const navigationLayouts = {
  auroraMotion: {
    id: 'auroraMotion',
    label: 'Aurora Motion',
    description:
      'Based on the animated dark-light sidebar concept with a glowing vertical panel, richer gradients, and stronger motion cues.',
    tags: ['Default', 'Animated', 'Dark glass'],
    referenceUrl:
      'https://www.figma.com/design/Xof7UniBlL62bdeiFC8eig/Sidebar-Navigation-Menu-for-Dashboard-%E2%80%93-Animation--Dark---Light-Versions---Community-?node-id=80-1461&p=f&t=ScLVbrQe44Ld5jNy-0',
  },
  cleanDashboard: {
    id: 'cleanDashboard',
    label: 'Clean Dashboard',
    description:
      'Inspired by the clean white dashboard navigation with a simple business header, slim utility strip, and quiet active states.',
    tags: ['Light', 'Business', 'Utility rail'],
    referenceUrl:
      'https://www.figma.com/design/eBKLUFStjPrgFJPNHgD8M7/Sidebar-Navigation-Dashboard--Community-?node-id=0-1&p=f&t=FyxUAPRXB5370f4s-0',
  },
  componentSidebar: {
    id: 'componentSidebar',
    label: 'Component Sidebar',
    description:
      'Adapted from the soft purple component-driven sidebar with a companion utility rail and a stronger promo block at the bottom.',
    tags: ['Soft', 'Promo', 'Component kit'],
    referenceUrl:
      'https://www.figma.com/design/hMVPBWhvQpHrGgaMoN9QiG/Animated-Sidebar-for-Web-Dashboards--Community-?node-id=20-2793&p=f&t=3xB4a48sanY8tV8q-0',
  },
  workspaceDark: {
    id: 'workspaceDark',
    label: 'Workspace Dark',
    description:
      'Matches the interactive dark workspace sidebar with inline search, a clear page list, and a bottom profile module.',
    tags: ['Dark', 'Search', 'Profile footer'],
    referenceUrl:
      'https://www.figma.com/design/RGAaIRhTkZjc1U2iE4VqkL/Sidebar-with-Interactive-Prototype--Community-?node-id=2-6237&p=f&t=eeYtip8OYl17SwME-0',
  },
};

export const navigationLayoutList = Object.values(navigationLayouts);

export function getNavigationLayout(layoutId) {
  return navigationLayouts[layoutId] || navigationLayouts[DEFAULT_NAVIGATION_LAYOUT];
}
